<template>
  <header class="header">
    <!-- Logo -->
    <div class="logo-container">
      <img src="@/assets/Devils-Armament-Logo-white-on-black-Transparent.png"
           alt="Devil's Armament Logo" class="logo" />
    </div>

    <!-- Navigation Menu -->
    <nav class="nav-menu">
      <router-link to="/Home" class="nav-link">Home</router-link>
      <router-link to="/products" class="nav-link">Products</router-link>
      <router-link to="/about-us" class="nav-link">About Us</router-link>
      <router-link to="/blog" class="nav-link">Blog</router-link>
      <router-link to="/contact" class="nav-link">Contact</router-link>
    </nav>

    <!-- CTA Button and Search Bar -->
    <div class="header-actions">
      <button class="cta-button">
        <font-awesome-icon :icon="['fas', 'shopping-cart']" />&nbsp; Pre-Order Now
      </button>
      <input type="text" class="search-bar" placeholder="Search..." />
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background-color: #333;
  color: white;
}

.logo-container {
  flex: 1;
  display: flex;
  justify-content: flex-start;
}

.logo {
  max-width: 200px; /* Set a max width to control size */
  height: auto; /* Maintain aspect ratio */
}

.nav-menu {
  display: flex;
  gap: 20px;
  flex: 2;
  justify-content: center;
}

.nav-link {
  color: white;
  text-decoration: none;
  font-weight: bold;
}

.nav-link:hover {
  text-decoration: underline;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.cta-button {
  display: flex;
  align-items: center;
  background-color: crimson;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
}

.cta-button:hover {
  background-color: darkred;
}

.search-bar {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  outline: none;
}

.search-bar:focus {
  border-color: crimson;
}
</style>
